import VerifyResetPasswordCode from '@pages/verify-reset-password-code/verify-reset-password-code';
export default VerifyResetPasswordCode;
